import { cn } from '@/utils'
import { useHelpFeedback } from './helpFeedbackContext'
import { TELL_US } from './helpFeedbackText'

/**
 * "Tell us what happened" under something that failed (SA-1306 spec §2.4): opens the Help & feedback
 * panel with the failure as its opening. Inside the shell it reads the panel's hook; it renders
 * nothing where the panel is not offered.
 */
export function TellUsLink({ message, className }: { message: string; className?: string }) {
  const helpFeedback = useHelpFeedback()
  if (!helpFeedback.available) return null
  return (
    <button
      type="button"
      className={cn('text-xs font-medium text-primary underline-offset-2 hover:underline', className)}
      onClick={() => helpFeedback.open({ failure: { message } })}
    >
      {TELL_US}
    </button>
  )
}
